export const decodePolyline = (encoded) => {
  const poly = [];
  let index = 0,
    lat = 0,
    lng = 0;
  while (index < encoded.length) {
    let result = 0,
      shift = 0;
    let c;
    do {
      c = encoded.charCodeAt(index++) - 63;
      result |= (c & 0x1f) << shift;
      shift += 5;
    } while (c >= 0x20);
    const dlat = result & 1 ? ~(result >> 1) : result >> 1;
    lat += dlat;
    result = 0;
    shift = 0;
    do {
      c = encoded.charCodeAt(index++) - 63;
      result |= (c & 0x1f) << shift;
      shift += 5;
    } while (c >= 0x20);
    const dlng = result & 1 ? ~(result >> 1) : result >> 1;
    lng += dlng;
    poly.push([lng / 1e5, lat / 1e5]);
  }
  return poly;
};
